<template>
  <div class="end">
    <div class="end-container">
      <Header :inShare='isWx'></Header>
      <div class="end-title"></div>
      <div class="end-redpacket">
        <div class="end-redpacket-btn">活动已经结束</div>
        <span class="end-redpacket-text">请关注我们的后续活动</span>
      </div>
      <div class="end-footer"></div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { isWeixin } from '@/utils';
import { mapActions } from 'vuex';
import qs from 'qs';
const query = qs.parse(window.location.search.slice(1));

export default {
  name: 'end',
  components: {
    Header
  },
  data() {
    return {};
  },
  computed: {
    isWx: ()=>{
      return isWeixin();
    }
  },
  mounted() {
    if (!this.isWx) {
      this.appLogin({ loginParam: query.loginParams })
    }
  },
  methods: {
    ...mapActions(['appLogin'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';

.end {
  @include set-image('../assets/images/home-bg1.jpg');
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &-container {
    @include set-size(750, 1182);
    position: relative;
  }
  &-title {
    @include set-image('../assets/images/home-title.png');
    @include set-size(677, 480);
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
    @include set-property(top, 100);
  }
  &-redpacket {
    @include set-image('../assets/images/home-redpacket.png');
    @include set-size(385, 514);
    @include set-property(top, 450);
    position: relative;
    margin: 0 auto;
    z-index: 11;
    &-btn {
      @include set-image('../assets/images/home-redpacket-btn.png');
      @include set-size(258, 60);
      position: absolute;
      margin: auto;
      right: 0;
      left: 0;
      color: #81010a;
      @include set-property(top, 230);
      @include set-property(font-size, 30.5);
      @include set-property(line-height, 60);
    }
    &-text {
      width: 100%;
      text-align: center;
      position: absolute;
      @include set-property(font-size, 28);
      @include set-property(top, 330);
      color: #ffffff;
      margin: auto;
      right: 0;
      left: 0;
    }
  }
  &-footer {
    @include set-image('../assets/images/home-footer.png');
    @include set-size(750, 900);
    @include set-rb(0, -240);
  }
}
@media (min-aspect-ratio: 750/1182) {
  .end {
    height: 100%;
  }
}
</style>
